"use client";

// Sanity.io imports
import { PortableText } from "next-sanity";

// Hooks, Utility & Helper function imports
import { createPortableTextComponents } from "@/utils/portableTextComponents";
import { t } from "@/utils/t";

import { IsovContentSwitcher } from "@/components/stencil";

interface ContentSwitcherProps {
  theme?: string;
  contentSwitcherItems?: any;
  activeTab?: number;
  locale?: string;
  skeleton?: boolean;
}

export default function ContentSwitcher({
  theme,
  contentSwitcherItems,
  activeTab = 1,
  locale = "en",
  skeleton,
}: ContentSwitcherProps) {
  const ptComponents = createPortableTextComponents(locale);
  const labels = contentSwitcherItems?.map((item: any) =>
    t(item?.label, locale),
  );

  return (
    <IsovContentSwitcher
      theme={theme}
      labels={labels}
      active={activeTab}
      skeleton={skeleton}
    >
      {contentSwitcherItems?.map((item: any) => (
        <div key={`switcher-item-${item?._id}`} className="content-item">
          {item?.text && (
            <>
              {typeof item?.text === "string" ? (
                item?.text
              ) : (
                <PortableText
                  value={t(item?.text, locale)}
                  components={ptComponents}
                  onMissingComponent={(message, options) => {
                    console.warn(message, {
                      type: options.type,
                      nodeType: options.nodeType,
                    });
                  }}
                />
              )}
            </>
          )}
        </div>
      ))}
    </IsovContentSwitcher>
  );
}
